module.exports = __webpack_public_path__ + "static/media/derby25.4d16cd29.svg";